export default __webpack_public_path__ + "static/media/tented.96973579.png";